import { useEffect, useRef, useState } from "react";

function useBarcodeQueue({
  Base_Uri,
  products,
  cart,
  openEditCartDetailModal,
  handleSelectProduct,
  notification,
  playBeep,
  setHighlightedProduct
}) {
  const [barcodeQueue, setBarcodeQueue] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  // Helper to add a barcode to the queue
  const enqueueBarcode = (barcode) => {
    if (barcode) {
      setBarcodeQueue((prev) => [...prev, barcode]);
    }
  };

  // Process queue — always one barcode at a time
  const processQueue = async () => {
    if (isProcessing || barcodeQueue.length === 0 || openEditCartDetailModal)
      return;

    setIsProcessing(true);
    const barcode = barcodeQueue[0];

    try {
      //console.log("Processing barcode:", barcode);
      const productInputRef = document.getElementById("productInputRef");
      productInputRef?.blur();

      // Try to find locally
      let product =
        products?.length > 0 &&
        products.find((e) => e?.barcode == barcode);

      // Fetch if not found locally
      let dataToken = JSON.parse(await sessionStorage.getItem("userData"));
      let token = dataToken;

      const response = await fetch(`${Base_Uri}getProducts?rawBarcode=${barcode}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      product = data?.data?.[0] || product;

      if (product) {
        handleSelectProduct(product);
        const existsInCart = cart?.find(
          (item) => item.barcode === product.barcode
        );
         setHighlightedProduct(product.barcode);
        //console.log("Product added:", product.barcode, existsInCart ? "(already in cart)" : "");
      } else {
        notification.error({
          message: "Product Not Found",
          description: "Product didn't exist or try again",
          placement: "bottomRight",
        });
        playBeep();
      }
    } catch (err) {
      console.error("Error processing barcode:", err);
      notification.error({
        message: "Network Error",
        description: "Could not fetch product. Retrying...",
        placement: "bottomRight",
      });
      playBeep();

      // Retry logic: requeue the same barcode after delay
      setTimeout(() => {
        setBarcodeQueue((prev) => [...prev, barcode]);
      }, 3000);
    } finally {
      // Remove processed barcode
      setBarcodeQueue((prev) => prev.slice(1));
      setIsProcessing(false);
    }
  };

  // Whenever queue changes, try to process
  useEffect(() => {
    if (!isProcessing && barcodeQueue.length > 0) {
      processQueue();
    }
  }, [barcodeQueue, isProcessing, openEditCartDetailModal]);

  return enqueueBarcode;
}

export default useBarcodeQueue;
